import React from 'react'
import {Button, Spinner} from "reactstrap";

const NewButton = ({children, disabled, loading, handleClick}) =>
    <Button
        type='submit'
        className='me-1'
        disabled={disabled || false}
        onClick={handleClick}
        size="sm"
        color='success'>
        {loading ? <Spinner size="sm" className="me-1" /> : <i className="fa fa-save me-1"/>}

        {children || "Salva"}
    </Button>

export default NewButton